import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material';
import { EventMessageComponent, ErrorMessageComponent } from '@app/shared';

@Injectable()
export class NotificationService {
  constructor(private snackBar: MatSnackBar) {}

  handleServiceEvent(message: string): void {
    this.snackBar.openFromComponent(EventMessageComponent, <MatSnackBarConfig>{
      duration: 3000,
      verticalPosition: 'top',
      horizontalPosition: 'center',
      data: {
        message: message
      }
    });
  }

  handleServiceError(op: string, err: any): void {
    this.snackBar.openFromComponent(ErrorMessageComponent, <MatSnackBarConfig>{
      duration: 6000,
      extraClasses: ['error-msg'],
      verticalPosition: 'top',
      horizontalPosition: 'center',
      data: {
        op: op,
        err: err.message
      }
    });
    console.error(`${op} error: ${err.message || err}`);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/notification.service.ts